
























import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import CDynamicForm from '~/components/shared/configurable/dynamic-form/CDynamicForm.vue'
import UserExtrasService from '~/services/user/UserExtrasService'
import { useDep } from '~/compositions/dependency-container'
import {
  DynamicFormFieldErrors,
  DynamicFormFieldValues,
  DynamicFormSchema
} from '~/models/dynamic-form/schema'
import { handleError } from '~/utils/http'
import { useLogger } from '~/compositions/logger'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { toSnakeCase } from '~/utils/snake-case'

export default defineComponent({
  components: { CDynamicForm },
  setup(_, { emit }) {
    const userExtrasService = useDep(UserExtrasService)
    const loading = ref(false)
    const fieldSchema = ref<DynamicFormSchema | null>(null)
    const fieldErrors = ref<DynamicFormFieldErrors>({})
    const fieldValues = ref<DynamicFormFieldValues>({})
    const logger = useLogger()
    const snackbar = useSnackbar()
    const { t } = useI18n()
    const { dispatch: userDispatch } = useNamespacedStore<UserState>(USER_NS)

    useFetch(async () => {
      await fetchShemaAndValues()
    })

    const fetchShemaAndValues = async () => {
      loading.value = true
      try {
        const {
          schema,
          user
        } = await userExtrasService.getUserBasicInfoSchema()

        fieldValues.value = toSnakeCase(user)
        fieldSchema.value = schema
      } catch (error) {
        handleError(error, snackbar, logger, t)
      } finally {
        loading.value = false
      }
    }

    const save = async () => {
      loading.value = true
      try {
        await userExtrasService.saveUSerBasicInfo(fieldValues.value)

        snackbar.success(t('account details saved successfully'))
        userDispatch('loadUser')
        emit('success')
      } catch (error) {
        const validationErrors = (error as any).response?.data?.data?.errors
        if (validationErrors) {
          fieldErrors.value = validationErrors
        } else {
          handleError(error, snackbar, logger, t)
        }
      } finally {
        loading.value = false
      }
    }

    return {
      fieldSchema,
      fieldErrors,
      fieldValues,
      loading,
      save
    }
  }
})
